import { Flex, Skeleton, Tag } from "@chakra-ui/react";
import { useContext } from "react";

import { ContributionContext } from "../context";

export function Tags() {
  const { tags, isLoaded, showTags } = useContext(ContributionContext);

  if (!showTags || !tags || tags.length === 0) return null;

  if (!isLoaded) {
    return <Skeleton h="20px" w="50%" borderRadius="md" />;
  }

  return (
    <Flex gap={2} wrap="wrap">
      {tags.map((tag: string) => (
        <Tag
          key={tag}
          colorScheme="gray"
          variant="subtle"
          style={{ direction: "rtl" }}
          data-testid="card-FooterTag"
        >
          {tag}
        </Tag>
      ))}
    </Flex>
  );
}
